import { render, staticRenderFns } from "./AddGraphBox.vue?vue&type=template&id=ca88f390&"
import script from "./AddGraphBox.vue?vue&type=script&lang=js&"
export * from "./AddGraphBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports